<template>
  <div class="offscreen">
    <div class="sidenav" :class="{ 'is-open': isOpen }">
      <div class="row p-4">
        <div class="col">
          <div class="d-flex justify-content-end">
            <smtt-icon icon="close" @click="$emit('onClose')" />
          </div>
          <profile-picture :user-full-name="userFullName" />
        </div>
      </div>
      <div class="row px-8">
        <div class="col">
          <MenuButton
            class="d-none d--md-flex"
            icon="info-circle"
            :text="$t('burgerMenu.about')"
            @click="showAboutModal = true"
          />
          <MenuButton
            class="d-flex d--md-none"
            icon="info-circle"
            :text="$t('burgerMenu.about')"
            @click="seeAbout"
          />
          <MenuButton
            class="d-flex d--md-none"
            icon="language"
            :text="$t('burgerMenu.language')"
            @click="seeLanguage"
          />
          <MenuButton
            class="d-none d--md-flex"
            icon="user"
            :text="$t('burgerMenu.profile')"
            @click="showProfileModal = true"
          />
          <MenuButton
            class="d-flex d--md-none"
            icon="user"
            :text="$t('burgerMenu.profile')"
            @click="seeProfile"
          />
          <MenuButton
            class="d-flex"
            icon="bell"
            :disabled="!canEnableNotification"
            :text="$t('burgerMenu.enableNotifications')"
            @click="enableNotification"
          />
          <MenuButton
            v-if="hasAdminPermission"
            icon="exchange-alt"
            :text="$t('burgerMenu.goToAdmin')"
            @click="goToAdmin"
          />
          <MenuButton
            v-if="isTutorialVideoEnabled"
            icon="eye"
            :text="$t('sharedComponents.videoModal.title')"
            @click="openVideoDialog"
          />
          <MenuButton
            class="mt-6"
            icon="sign-out-alt"
            :text="$t('burgerMenu.logout')"
            @click="logOut"
          />
        </div>
      </div>
    </div>
    <ProfileModal
      :show="showProfileModal"
      @dismiss="showProfileModal = false"
    />
    <AboutModal :show="showAboutModal" @dismiss="showAboutModal = false" />
  </div>
</template>

<script>
import store from "../../store/store";
import ProfileModal from "@/components/hamburgerMenu/components/ProfileModal.vue";
import MenuButton from "@/components/hamburgerMenu/components/MenuButton.vue";
import AboutModal from "@/components/hamburgerMenu/components/AboutModal.vue";
import ProfilePicture from "@/components/ProfilePicture";
import { initializeFCM } from "../../utils/firebase";

export default {
  name: "hamburguerMenu",
  components: { AboutModal, MenuButton, ProfileModal, ProfilePicture },
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showProfileModal: false,
      showAboutModal: false,
      userFullName: "",
      canEnableNotification: false,
    };
  },
  computed: {
    isTutorialVideoEnabled() {
      return this.$store.state.isTutorialVideoEnabled;
    },
    hasAdminPermission() {
      return this.$store.getters.HasAdminPermission();
    },
  },
  methods: {
    seeAbout() {
      this.$router.push({ name: "About" });
    },
    seeLanguage() {
      this.$router.push({ name: "Language" });
    },
    seeProfile() {
      this.$router.push({ name: "Profile" });
    },
    goToAdmin() {
      window.location.replace(store.getters.SystemUlrBase() + "/admin/");
    },
    logOut() {
      if (
        this.$store.getters.isKeycloakActive() &&
        this.$keycloak?.authenticated
      ) {
        store.dispatch("logoffUserFromKeycloak");

        this.$keycloak.logoutFn();
      } else {
        store.commit("clearSessionData");

        this.$router.replace({ name: "Login" });
      }
    },
    openVideoDialog() {
      this.$emit("showVideo");
    },
    enableNotification() {
      initializeFCM();
      this.canEnableNotification = false;
    },
  },
  created() {
    const user = this.$store.getters.GetUserData();
    this.userFullName = user.firstname + " " + user.lastname;
  },
  mounted() {
    if ("Notification" in window) {
      if (Notification.permission === "default") {
        this.canEnableNotification = true;
      } else {
        this.canEnableNotification = false;
      }
    }
  },
};
</script>

<style scoped>
.sidenav {
  height: 100%;
  width: 400px;
  position: fixed;
  z-index: 30;
  top: 52px;
  right: -450px;
  background-color: #ffffff;
  overflow-x: hidden;
  transition: 0.5s;
  padding-top: 52px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

.sidenav a:hover {
  color: #f1f1f1;
}

.sidenav.is-open {
  right: 0;
}

.menu-button {
  cursor: pointer;
}

.profile-info {
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  padding: 20px 0;
}

.profile-picture {
  background-color: #f5f5f5;
  width: 150px;
  height: 150px;
  border-radius: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.profile-name {
  font-weight: bold;
  font-size: 20px;
  margin: 30px 5px 0 5px;
}

.user-icon {
  width: 100px;
  height: 100px;
}

.offscreen {
  position: absolute;
}
</style>
